<template>
  <div data-parent="true" class="vc_row style-color-lxmt-bg row-container event-grid" id="row-unique-1" data-section="1">
    <div class="row single-top-padding double-bottom-padding single-h-padding limit-width row-parent" data-imgready="true">
      <div class="wpb_row row-inner">
        <div class="wpb_column pos-top pos-center align_left column_parent col-lg-12 single-internal-gutter">
          <div class="uncol style-light">
            <div class="uncoltable">
              <div class="uncell no-block-padding">
                <div class="uncont">
                  <div id="index-983897" class="isotope-system isotope-general-light slideNews isotope-processed">
                    <div class="isotope-filters0 menu-container has-cat-filters menu-animated single-gutter mobile-dropdown submenu-light  no-text-uppercase menu-light">
                      <div class="menu-horizontal limit-width text-left text-mobile-left filter-alignment-left ">
                        <div class="event-grid--filters">
                          <EventFilter v-model="state.category" />
                          <EventSearch class="event-grid--filters-search" v-model="state.search" />
                        </div>
                      </div>
                    </div>

                    <div class="isotope-wrapper single-gutter">
                      <div class="isotope-container isotope-layout style-masonry isotope-pagination un-isotope-init" style="position: relative; opacity: 1;" data-type="masonry" data-layout="fitRows" data-lg="1000" data-md="600" data-sm="480" data-vp-height="" data-iso-index="0">
                        <LoadingSpinner v-if="state.loading" />
                        <EventItem v-for="event in state.events" :event="event" />
                        <p v-if="state.events.length === 0 && !state.loading">No events found</p>
                      </div>
                    </div>

                    <div class="isotope-footer style-light single-gutter" style="opacity: 1;">
                      <div class="isotope-footer-inner limit-width menu-light text-center">
                        <Pager
                          v-if="state.events.length > 0"
                          :items-per-page="state.pager.items_per_page"
                          :total-items="state.pager.total_num_items"
                          v-model="state.currentPage"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import EventFilter from "@/components/domain/event/EventFilter.vue";
import EventItem from "@/components/domain/event/EventItem.vue";
import EventSearch from "@/components/domain/event/EventSearch.vue";
import Pager from "@/components/common/Pager.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import { EventCategory } from "@/domain/events/event-category";
import { Event } from "@/domain/events/event";
import { FetchEventsOptions, fetchEvents as eventsRequest } from "@/helpers/events";
import { reactive, watch, toRefs } from "vue";
import { PaginationMetadata } from "@/domain/shared/wordpress/ajax-response-metadata";

class ComponentState {
  category: EventCategory = EventCategory.LATEST;
  events: Array<Event> = [];
  pager: PaginationMetadata = new PaginationMetadata();
  currentPage: number = 1;
  search: string = '';
  loading: boolean = false;
}

const state = reactive(new ComponentState());
const { category, currentPage, search } = toRefs(state);

const fetchOptions = (): FetchEventsOptions => ({
  category: state.category,
  page: state.currentPage,
  search: state.search,
});

function fetchEvents() {
  state.events = []
  state.loading = true;

  eventsRequest(fetchOptions()).then((response) => {
    state.events = response.data;
    state.pager = response.meta.pagination;
    state.loading = false;
    const grid = document.getElementById('inc-events-grid');

    if (window.scrollY > grid.offsetTop) {
      window.scrollTo(0, grid.offsetTop);
    }
  });
}

/**
 * Watch filter changes
 */
const categoryWatcher = () => {
  state.currentPage = 1;
  fetchEvents();
};

watch(category, categoryWatcher, { immediate: true });
watch(currentPage, () => fetchEvents());
watch(search, () => fetchEvents());
</script>

<style scoped lang="scss">
  .isotope-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    > p {
      margin-top: 100px;
    }
  }

  .event-grid {
    &--filters {
      display: flex;
      justify-content: space-between;
      width: 100%;

      &-search {
        width: 50%;
      }
    }
  }
</style>
